var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 90 l 5.433 -23.57 C 1.871 59.866 0 52.516 0 45 C 0 20.187 20.187 0 45 0 c 24.813 0 45 20.187 45 45 c 0 24.813 -20.187 45 -45 45 c -7.516 0 -14.866 -1.871 -21.43 -5.434 L 0 90 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(58,108,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 66.609 51.5 c -0.42 0 -0.85 -0.04 -1.27 -0.13 c -0.41 -0.08 -0.82 -0.21 -1.22 -0.37 c -0.391 -0.16 -0.771 -0.36 -1.12 -0.601 c -0.351 -0.229 -0.69 -0.5 -0.98 -0.8 c -0.31 -0.3 -0.58 -0.64 -0.81 -0.99 c -0.24 -0.35 -0.44 -0.729 -0.601 -1.119 c -0.17 -0.4 -0.29 -0.801 -0.369 -1.221 c -0.091 -0.42 -0.131 -0.85 -0.131 -1.27 c 0 -0.42 0.04 -0.85 0.131 -1.27 c 0.079 -0.41 0.199 -0.82 0.369 -1.22 c 0.16 -0.39 0.36 -0.77 0.591 -1.12 c 0.239 -0.35 0.51 -0.69 0.81 -0.99 c 0.3 -0.3 0.64 -0.57 0.99 -0.8 c 0.35 -0.24 0.729 -0.44 1.12 -0.6 c 0.399 -0.16 0.81 -0.29 1.22 -0.37 c 0.84 -0.17 1.7 -0.17 2.54 0 c 0.41 0.08 0.82 0.21 1.22 0.37 c 0.391 0.16 0.76 0.36 1.12 0.6 c 0.35 0.23 0.69 0.5 0.99 0.8 c 0.3 0.3 0.57 0.64 0.8 0.99 c 0.24 0.35 0.44 0.73 0.6 1.12 c 0.16 0.4 0.29 0.81 0.37 1.22 c 0.09 0.42 0.13 0.85 0.13 1.27 c 0 0.42 -0.04 0.85 -0.13 1.27 c -0.08 0.41 -0.21 0.82 -0.37 1.221 c -0.159 0.39 -0.359 0.77 -0.6 1.119 c -0.229 0.351 -0.5 0.69 -0.8 0.99 s -0.641 0.57 -0.99 0.8 c -0.36 0.24 -0.729 0.44 -1.12 0.601 c -0.399 0.16 -0.81 0.29 -1.22 0.37 C 67.46 51.46 67.03 51.5 66.609 51.5 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 51.5 c -0.42 0 -0.85 -0.04 -1.27 -0.13 c -0.41 -0.08 -0.82 -0.21 -1.22 -0.37 c -0.39 -0.16 -0.77 -0.36 -1.12 -0.601 c -0.35 -0.229 -0.69 -0.5 -0.99 -0.8 c -1.21 -1.21 -1.9 -2.89 -1.9 -4.6 c 0 -0.42 0.04 -0.85 0.13 -1.27 c 0.08 -0.41 0.2 -0.82 0.37 -1.22 c 0.16 -0.39 0.36 -0.77 0.6 -1.12 c 0.23 -0.35 0.5 -0.69 0.8 -0.99 c 0.3 -0.3 0.64 -0.57 0.99 -0.8 c 0.35 -0.24 0.73 -0.44 1.12 -0.6 c 0.4 -0.17 0.81 -0.29 1.22 -0.37 c 2.11 -0.43 4.36 0.26 5.87 1.77 c 0.3 0.3 0.57 0.64 0.8 0.99 c 0.24 0.35 0.44 0.73 0.601 1.12 c 0.16 0.4 0.29 0.81 0.37 1.22 c 0.09 0.42 0.13 0.85 0.13 1.27 c 0 1.71 -0.69 3.39 -1.91 4.6 C 48.39 50.81 46.71 51.5 45 51.5 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 23.39 51.5 c -0.42 0 -0.85 -0.04 -1.27 -0.13 c -0.41 -0.08 -0.82 -0.21 -1.22 -0.37 c -0.39 -0.16 -0.77 -0.36 -1.12 -0.601 c -0.35 -0.229 -0.69 -0.5 -0.99 -0.8 c -1.21 -1.21 -1.9 -2.89 -1.9 -4.6 c 0 -0.42 0.04 -0.85 0.13 -1.27 c 0.08 -0.41 0.2 -0.82 0.37 -1.22 c 0.16 -0.39 0.36 -0.77 0.6 -1.12 c 0.23 -0.35 0.5 -0.69 0.8 -0.99 c 0.3 -0.3 0.64 -0.57 0.99 -0.8 c 0.35 -0.24 0.73 -0.44 1.12 -0.6 c 0.4 -0.17 0.81 -0.29 1.22 -0.37 c 0.84 -0.17 1.7 -0.17 2.54 0 c 0.42 0.08 0.82 0.2 1.22 0.37 c 0.39 0.16 0.77 0.36 1.12 0.6 c 0.35 0.23 0.69 0.5 0.99 0.8 c 0.3 0.3 0.57 0.64 0.8 0.99 c 0.24 0.35 0.44 0.73 0.6 1.12 c 0.16 0.4 0.29 0.81 0.37 1.22 c 0.09 0.42 0.13 0.85 0.13 1.27 c 0 1.71 -0.69 3.39 -1.91 4.6 C 26.78 50.81 25.1 51.5 23.39 51.5 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/Message.c0e51f7ede1f6dc57d5dd1814987516a.svg";
export { ForwardRef as ReactComponent };